
import {
  defineComponent,
  onMounted,
  watch,
  computed,
  ref,
  watchEffect,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent, DrawerComponent } from "@/assets/ts/components";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import VPagination from "@hennge/vue3-pagination";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AppService from "@/core/services/AppService";
import { renderImageUrl } from "@/core/services/AppService";
import { Actions, ActionsConfigs } from "@/store/enums/StoreEnums";
import { ValuationDefault, ValuationModel } from "@/store/model/Valuation";
import { statusDataForm } from "@/core/config/AppConfig";

export default defineComponent({
  name: "valuation-data",
  components: { VPagination },
  props: {
    page: {
      type: String,
      default: "1",
    },
    limit: {
      type: String,
      default: "20",
    },
    email: {
      type: String,
      default: "",
    },
    order: {
      type: String,
      default: "desc",
    },
    order_by: {
      type: String,
      default: "created_at",
    },
    search: {
      type: String,
      default: "{}",
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const domain_FE = process.env.VUE_APP_HOME_FE;
    let params = {
      page: parseInt(props.page),
      limit: parseInt(props.limit),
      email: props.email,
      order: props.order,
      order_by: props.order_by,
      search: props.search,
    };
    const s_status = ref("");
    const drawer = ref(false);
    const s_name = ref();
    const limitData = [5, 10, 20, 50, 100];
    const action_get_data = Actions.GET_ALL_VALUATION;
    const dataItem = ref<ValuationModel>(ValuationDefault);
    store.dispatch(action_get_data, AppService.convertParams(params));
    const listData = computed(() => store.getters["listDataValuations"]);
    const totalPages = computed(() => store.getters["getValuationPages"]);
    const totalDocs = computed(() => store.getters["getTotalValuations"]);
    const totalPending = computed(() => store.getters["getValuationPending"]);
    const onChangePage = async (next_page) => {
      params.page = next_page;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "data_valuation"
      );
    };
    const showDetailData = async (data: ValuationModel) => {
      drawer.value = true;
      dataItem.value = data;
    };
    const onChangeLimit = async (event) => {
      let positionMax =
        params.limit * params.page > totalDocs.value
          ? totalDocs.value
          : params.limit * params.page;
      params.limit = event.target.value;
      params.page =
        Math.ceil(positionMax / params.limit) > 0
          ? Math.ceil(positionMax / params.limit)
          : 1;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "data_valuation"
      );
    };
    const onClickSort = async (order_by) => {
      params.order_by = order_by;
      params.order = params.order === "desc" ? "asc" : "desc";
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "data_valuation"
      );
    };
    const onSearch = async () => {
      let searchObject = {};
      if (s_name.value.trim() != "") {
        searchObject["name"] = s_name.value;
      }
      if (s_status.value.trim() != "") {
        searchObject["status"] = s_status.value;
      }
      params.search = JSON.stringify(searchObject);
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "data_valuation"
      );
    };
    store.dispatch(
      Actions.GET_TOTAL_PENDING_VALUATION,
      AppService.convertParams({
        page: 1,
        limit: 1,
        search: '{ "status": "pending" }',
      })
    );
    const directionData = ref();
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Form định giá", ["Data Form"]);
      MenuComponent.reinitialization();
      let searchObject = JSON.parse(params.search);
      await store.dispatch(ActionsConfigs.GET_DIRECTION);
      directionData.value = store.getters["getDirection"];
      s_name.value = searchObject.name ? searchObject.name : "";
      s_status.value = searchObject.status ? searchObject.status : "";
    });
    const onClickDelete = (id) => {
      Swal.fire({
        text: "Bạn chắc chắn muốn xóa chứ ?",
        icon: "warning",
        buttonsStyling: false,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        customClass: {
          confirmButton: "btn fw-bold btn-light-danger",
          cancelButton: "btn fw-bold btn-primary",
        },
      }).then(function (result) {
        let searchString = AppService.convertParams(params);
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_VALUATION, {
              id,
              searchString,
            })
            .then(() => {
              Swal.fire({
                text: "Xóa thành công",
                icon: "success",
                buttonsStyling: false,
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  confirmButton: "btn fw-bold btn-light-success",
                  cancelButton: "btn fw-bold btn-light-primary",
                },
              }).then(function (result) {
                // Go to page after successfully login
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getErrors[0],
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Try again!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
        }
      });
    };
    const updateStatus = (objectUpdate) => {

      objectUpdate.id = objectUpdate._id;
      store.dispatch(
        Actions.UPDATE_VALUATION,
        objectUpdate
      );
    };
    return {
      updateStatus,
      onClickDelete,
      statusDataForm,
      s_status,
      showDetailData,
      drawer,
      directionData,
      s_name,
      listData,
      domain_FE,
      params,
      limitData,
      totalDocs,
      totalPages,
      onChangePage,
      dataItem,
      onChangeLimit,
      onClickSort,
      renderImageUrl,
      totalPending,
      onSearch,
    };
  },
});
